import { render, staticRenderFns } from "./TagRow.vue?vue&type=template&id=8349a97c&scoped=true&"
import script from "./TagRow.vue?vue&type=script&lang=js&"
export * from "./TagRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=8349a97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8349a97c",
  null
  
)

export default component.exports